// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-login {
  padding: 20px;
  font-family: 'Arial', sans-serif;
}

.time-group {
  margin-bottom: 1rem;
}

.time-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  padding: 12px 16px;
  border-radius: 12px 12px 0 0;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #ddd;
  border-bottom: none;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: #f8f9fa;
  padding: 12px;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 12px 12px;
  width: 100%;
  box-sizing: border-box;
}

/* Employee card styles */
.employee-card-hover {
  position: relative;
  width: 180px; /* Smaller width for more cards in a row */
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin: 5px;
  flex-shrink: 0;
  flex-grow: 0;
}

.card-main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
  box-sizing: border-box;
  width: 100%;
}

/* Profile Section */
.profile-section-admin {
  display: flex!important;
  align-items: center!important;
  gap: 0px!important;
  margin-bottom: 8px!important;
}


.profile-img1 {
  width: 40px!important;
  height: 40px!important;
  border-radius: 50%!important;
  margin-left: -3%!important;
}

/* Time Section */
.time-section-centered {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  font-size: 0.75rem;
  margin: 6px 0;
}

.time-section-centered > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  text-align: center;
}

.time-section-centered .label {
  font-weight: normal;
  font-size: 0.7rem;
  color: #777;
  margin-bottom: 2px;
}

.green {
  color: green;
  font-weight: bold;
}

.red {
  color: red;
  font-weight: bold;
}

.hours,
.total-hours {
  font-weight: bold;
  font-size: 0.8rem;
  color: #333;
}

.total-hours span {
  display: block;
  font-weight: normal;
  font-size: 0.7rem;
  color: #777;
}

/* Location Section */
.location-section {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #555;
  gap: 4px;
  margin-top: 4px;
}

/* Icon at top */
.device-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 16px;
  color: #555;
}


.expand-icon {
  font-size: 1.2rem;
  color: #555;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f0f0f0;  /* Light gray background */
  padding: 4px;               /* Inner space around the icon */
  border-radius: 4px;         /* Slightly rounded corners */
  border: 1px solid #ccc;     /* Optional border */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;                /* Fixed width */
  height: 24px;               /* Fixed height */
  cursor: pointer;            /* Make it look clickable */
}

/* Popup Styles */
.card-popup {
  position: absolute;
  top: -130px;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
  max-height: 180px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  opacity: 1;
  transition: opacity 0.3s ease, transform 0.3s ease;
  overflow-y: auto;
}

.card-popup h4 {
  margin: 0 0 6px 0;
  font-size: 0.85rem;
  color: #333;
}

/* Define background for Office HQ */
.bg-office-hq {
  background-color: #ddd !important; /* DodgerBlue for distinct color */
}

/* Define default background */
.bg-default {
  background-color: #ffffff !important; /* White */
}

/* Punch History */
.punch-history {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.punch-entry {
  background: #f1f1f1;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  line-height: 1.3;
}

.punch-entry div {
  margin-bottom: 2px;
  color: #444;
}

.punch-entry div:last-child {
  margin-bottom: 0;
}

/* Hover Indicator */
.hover-indicator {
  position: absolute;
  top: 6px;
  left: 140px;
  color: rgb(47, 42, 42);
  padding: 4px;
  font-size: 0.65rem;
  border-radius: 50%;
  transition: opacity 0.3s ease;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.employee-card-hover:hover .hover-indicator {
  opacity: 1;
}

/* Divider */
.divider {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 5px 12px;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tab-buttons button {
  padding: 8px 16px;
  border: none;
  background-color: #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
}

.tab-buttons button.active {
  background-color: #79c42b;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeLogin/EmployeeLogin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;AAC9B;;;AAGA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB,GAAG,0BAA0B;EACtD,YAAY,gBAAgB,gCAAgC;EAC5D,kBAAkB,UAAU,6BAA6B;EACzD,sBAAsB,MAAM,oBAAoB;EAChD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,iBAAiB,gBAAgB;EAC5C,YAAY,gBAAgB,iBAAiB;EAC7C,eAAe,aAAa,2BAA2B;AACzD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,UAAU;EACV,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,iCAAiC,EAAE,kCAAkC;AACvE;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC,EAAE,UAAU;AAClD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".employee-login {\n  padding: 20px;\n  font-family: 'Arial', sans-serif;\n}\n\n.time-group {\n  margin-bottom: 1rem;\n}\n\n.time-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f8f9fa;\n  padding: 12px 16px;\n  border-radius: 12px 12px 0 0;\n  font-weight: bold;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  border-bottom: none;\n}\n\n.card-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  background-color: #f8f9fa;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 12px 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Employee card styles */\n.employee-card-hover {\n  position: relative;\n  width: 180px; /* Smaller width for more cards in a row */\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color: white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  margin: 5px;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.card-main {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 8px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n/* Profile Section */\n.profile-section-admin {\n  display: flex!important;\n  align-items: center!important;\n  gap: 0px!important;\n  margin-bottom: 8px!important;\n}\n\n\n.profile-img1 {\n  width: 40px!important;\n  height: 40px!important;\n  border-radius: 50%!important;\n  margin-left: -3%!important;\n}\n\n/* Time Section */\n.time-section-centered {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n  font-size: 0.75rem;\n  margin: 6px 0;\n}\n\n.time-section-centered > div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  text-align: center;\n}\n\n.time-section-centered .label {\n  font-weight: normal;\n  font-size: 0.7rem;\n  color: #777;\n  margin-bottom: 2px;\n}\n\n.green {\n  color: green;\n  font-weight: bold;\n}\n\n.red {\n  color: red;\n  font-weight: bold;\n}\n\n.hours,\n.total-hours {\n  font-weight: bold;\n  font-size: 0.8rem;\n  color: #333;\n}\n\n.total-hours span {\n  display: block;\n  font-weight: normal;\n  font-size: 0.7rem;\n  color: #777;\n}\n\n/* Location Section */\n.location-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  color: #555;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n/* Icon at top */\n.device-icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  font-size: 16px;\n  color: #555;\n}\n\n\n.expand-icon {\n  font-size: 1.2rem;\n  color: #555;\n  user-select: none;\n  background-color: #f0f0f0;  /* Light gray background */\n  padding: 4px;               /* Inner space around the icon */\n  border-radius: 4px;         /* Slightly rounded corners */\n  border: 1px solid #ccc;     /* Optional border */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;                /* Fixed width */\n  height: 24px;               /* Fixed height */\n  cursor: pointer;            /* Make it look clickable */\n}\n\n/* Popup Styles */\n.card-popup {\n  position: absolute;\n  top: -130px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 160px;\n  max-height: 180px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n  opacity: 1;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  overflow-y: auto;\n}\n\n.card-popup h4 {\n  margin: 0 0 6px 0;\n  font-size: 0.85rem;\n  color: #333;\n}\n\n/* Define background for Office HQ */\n.bg-office-hq {\n  background-color: #ddd !important; /* DodgerBlue for distinct color */\n}\n\n/* Define default background */\n.bg-default {\n  background-color: #ffffff !important; /* White */\n}\n\n/* Punch History */\n.punch-history {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.punch-entry {\n  background: #f1f1f1;\n  padding: 5px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  line-height: 1.3;\n}\n\n.punch-entry div {\n  margin-bottom: 2px;\n  color: #444;\n}\n\n.punch-entry div:last-child {\n  margin-bottom: 0;\n}\n\n/* Hover Indicator */\n.hover-indicator {\n  position: absolute;\n  top: 6px;\n  left: 140px;\n  color: rgb(47, 42, 42);\n  padding: 4px;\n  font-size: 0.65rem;\n  border-radius: 50%;\n  transition: opacity 0.3s ease;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.employee-card-hover:hover .hover-indicator {\n  opacity: 1;\n}\n\n/* Divider */\n.divider {\n  border: none;\n  border-top: 1px solid #e0e0e0;\n  margin: 5px 12px;\n}\n\n.tab-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.tab-buttons button {\n  padding: 8px 16px;\n  border: none;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.tab-buttons button.active {\n  background-color: #79c42b;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
